module.exports = __webpack_public_path__ + "assets/media/leo-face.33bef6e2.png";